
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { formatPhoneNumber } from "@/lib/utils";

export const usePhoneAuth = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSendOTP = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setLoading(true);
      console.log('[PHONE-AUTH] Sending OTP to phone number', { phoneNumber });
      
      // Format the phone number
      const formattedPhoneNumber = formatPhoneNumber(phoneNumber);
      console.log('[PHONE-AUTH] Formatted phone number:', formattedPhoneNumber);
      
      const { error } = await supabase.auth.signInWithOtp({
        phone: formattedPhoneNumber,
      });

      if (error) {
        console.error('[PHONE-AUTH] Error sending OTP:', error);
        throw error;
      }

      console.log('[PHONE-AUTH] OTP sent successfully');
      setIsVerifying(true);
      toast.success("Verification code sent to your phone");
    } catch (error: any) {
      console.error('[PHONE-AUTH] Error in handleSendOTP:', error);
      toast.error(error.message || "Error sending verification code");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setLoading(true);
      console.log('[PHONE-AUTH] Verifying OTP');
      
      // Format the phone number
      const formattedPhoneNumber = formatPhoneNumber(phoneNumber);
      console.log('[PHONE-AUTH] Using formatted phone number:', formattedPhoneNumber);
      
      const { data, error } = await supabase.auth.verifyOtp({
        phone: formattedPhoneNumber,
        token: verificationCode,
        type: "sms",
      });

      if (error) {
        console.error('[PHONE-AUTH] Error verifying OTP:', error);
        throw error;
      }

      // Only proceed if we have a user
      if (!data.user) {
        console.error('[PHONE-AUTH] Verification succeeded but no user was returned');
        throw new Error("Verification succeeded but no user was returned");
      }

      console.log("[PHONE-AUTH] User authenticated:", data.user.id);
      console.log("[PHONE-AUTH] Session established:", !!data.session);
      
      toast.success("Phone number verified successfully");
      console.log('[PHONE-AUTH] Authentication complete, waiting for AuthProvider to handle navigation');
      
    } catch (error: any) {
      console.error("[PHONE-AUTH] Verification error:", error);
      toast.error(error.message || "Error verifying code");
    } finally {
      setLoading(false);
    }
  };

  return {
    phoneNumber,
    setPhoneNumber,
    verificationCode,
    setVerificationCode,
    isVerifying,
    loading,
    handleSendOTP,
    handleVerifyOTP,
  };
};
